<h2 mat-dialog-title class="title">{{'TERM_AND_CONDITIONS.' + title | translate}}</h2>
<mat-dialog-content>
	<!-- <iframe width="100%" height="500" [src]="webViewSrc"></iframe> -->
    <div class="container">
        <ng-container *ngIf="data.type == 'registration'; else payment">
            <p *ngFor="let item of TERM_AND_CONDITION">{{ 'TERM_AND_CONDITIONS.' + item | translate}} </p>
        </ng-container>
        <ng-template #payment>
            <p *ngFor="let item of main_p">{{ 'TERM_AND_CONDITIONS.PAYMENT.' + item | translate}}  </p>
            <ng-container *ngFor="let item of TERM_AND_CONDITION">
                <h3>{{'TERM_AND_CONDITIONS.PAYMENT.' + item.title | translate }}</h3>
                <p *ngIf="item.desc">{{'TERM_AND_CONDITIONS.PAYMENT.' + item.desc | translate }}</p>

                <ng-container *ngIf="item?.child">
                    <ng-container  *ngFor="let child of item.child">
                        <h3>{{ 'TERM_AND_CONDITIONS.PAYMENT.' + child.title | translate }}</h3>
                        <p *ngFor="let text of child.p"  [innerHTML]="'TERM_AND_CONDITIONS.PAYMENT.' + text | translate"></p>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="item?.type === 'three'; else other">
                    <ul class="list">
                        <li *ngFor="let text of item.p">
                            <p>{{ 'TERM_AND_CONDITIONS.PAYMENT.' + text | translate}}</p>
                        </li>
                    </ul>
                </ng-container>

                <ng-template #other >
                    <p *ngFor="let text of item.p" [innerHTML]="'TERM_AND_CONDITIONS.PAYMENT.' + text | translate"></p>
                </ng-template>
            </ng-container>
        </ng-template>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="mat-custom-btn" mat-flat-button [mat-dialog-close]="data.token ? data.token : true" color="accent">{{ 'LABEL.AGREE' | translate }}</button>
</mat-dialog-actions>